<div class="carousel font-roboto text-base relative overflow-hidden flex flex-col items-center">
	<h1 class="mb-0">Customer Feedback</h1>
	<div class="testimonial w-full hidden justify-center items-start " *ngFor="let slide of slides; let i = index" [class.active]="i === currentSlideIndex">
		<div class="content text-white m-0 font-normal parent">
			<div class="left">
				<div class="profile-image fade-in-out" [class.fade]="fade" (animationend)="animationEndHandler($event)" [ngStyle]="{ 'background-image': 'url(' + slide.imageSrc + ')' }"></div>
			</div>
			<div class="right">
				<div class="fade-in-out" [class.fade]="fade" (animationend)="animationEndHandler($event)">
					<div class="horizontal-carousel comment">{{ slide.comment }}</div>
					<div class="vertical-carousel comment">{{ slide.comment }}</div>
					<div class="profile-info">
						<div class="profile-details m-0 mb-[8px]">
							<img src="{{slide.companyImage}}" width="114px" class="mb-[2px]">
							<div class="title">{{ slide.title }}</div>
							<div class="subtitle">{{ slide.subtitle }}</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div class="dots-navigation flex">
        <span class="dot" *ngFor="let slide of slides; let i = index" [class.active]="i === currentSlideIndex" (click)="goToSlide(i)"></span>
    </div>
</div>
